import ACTIONS from "../constants/actions";

const {
  GET_USER_SHIFT_TYPES_BY_TOKEN,
  GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS,
  GET_TODAY_USER_SHIFT_TYPES,
  GET_TODAY_USER_SHIFT_TYPES_SUCCESS,
  GET_TODAY_USER_SHIFT_TYPES_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingGetUserShiftTypes: false,
  isLoadingGetTodayUserShiftTypes: false,
  todayShiftTypes: [],
};

const userShiftTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_SHIFT_TYPES_BY_TOKEN:
      return {
        ...state,
        isLoadingGetUserShiftTypes: true,
      };
    case GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS:
      return {
        ...state,
        isLoadingGetUserShiftTypes: false,
        userShiftTypesData: action.payload,
      };
    case GET_TODAY_USER_SHIFT_TYPES:
      return {
        ...state,
        isLoadingGetTodayUserShiftTypes: true,
      };
    case GET_TODAY_USER_SHIFT_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingGetTodayUserShiftTypes: false,
        todayShiftTypes: action.payload,
      };
    case GET_TODAY_USER_SHIFT_TYPES_FAIL:
      return {
        ...state,
        isLoadingGetTodayUserShiftTypes: false,
      };
    default:
      return state;
  }
};
export default userShiftTypeReducer;
